import { TimePicker, Row, Col, Button, Card, Avatar } from "antd";
import { ClockCircleOutlined, CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
// import { cn } from "../../../../utils/cn";

const EnhancedSettingsBusinessHours = ({
    timeZone,
    days,
    handleTimeChange
}) => {
    const history = useHistory();
    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between gap-2 text-sm text-gray-600 bg-primary/10 p-3 rounded-lg w-full border border-primary/20">
                <div className="flex items-center gap-2">
                    <span className="font-medium text-primary">Your Timezone:</span>
                    <span className="font-bold text-gray-900">{timeZone}</span>
                </div>
                <Button
                    type="primary"
                    className="flex items-center gap-x-1 text-primary hover:!text-white hover:!bg-primary h-9 !bg-white !border !border-primary shadow-sm transition-all duration-200"
                    onClick={() => history.push("/profile?edit=true")}
                >
                    Change Timezone
                </Button>
            </div>

            <Row gutter={[12, 12]}>
                {days?.map((data, idx) => (
                    <Col span={12} key={data?.day}>
                        <Card
                            hoverable
                            className="h-full relative overflow-hidden"
                        >
                            <div className="space-y-4">
                                {/* Header */}
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center space-x-3 overflow-hidden">
                                        <Avatar
                                            size={48}
                                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                                            icon={<ClockCircleOutlined />}
                                        />
                                        <div className="min-w-0 flex-1">
                                            <h3 className="font-semibold text-base mb-1 truncate">
                                                {data?.name || "N/A"}
                                            </h3>
                                            <p className="text-gray-500 text-sm mb-0 truncate">
                                                Business Day
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Divider or spacing as per reference */}
                                <div className="space-y-2 border-b border-gray-200 pb-3" />

                                {/* Time Selection Section */}
                                <div className="grid grid-cols-2 gap-3 pt-1">
                                    <div className="space-y-1.5">
                                        <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider ml-0.5 flex items-center gap-1">
                                            <CalendarOutlined className="text-[12px]" />
                                            Start Time
                                        </label>
                                        <TimePicker
                                            className="w-full h-10 border-gray-200 hover:border-primary focus:border-primary rounded-lg bg-gray-50/50 text-xs shadow-none transition-all duration-200"
                                            format="HH:mm"
                                            value={data.startTime ? dayjs(data.startTime, "HH:mm") : null}
                                            onChange={(time) => handleTimeChange(idx, "startTime", time ? time.format("HH:mm") : null)}
                                            allowClear={false}
                                            inputReadOnly
                                        />
                                    </div>

                                    <div className="space-y-1.5">
                                        <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wider ml-0.5 flex items-center gap-1">
                                            <CalendarOutlined className="text-[12px]" />
                                            End Time
                                        </label>
                                        <TimePicker
                                            className="w-full h-10 border-gray-200 hover:border-primary focus:border-primary rounded-lg bg-gray-50/50 text-xs shadow-none transition-all duration-200"
                                            format="HH:mm"
                                            value={data.endTime ? dayjs(data.endTime, "HH:mm") : null}
                                            onChange={(time) => handleTimeChange(idx, "endTime", time ? time.format("HH:mm") : null)}
                                            allowClear={false}
                                            inputReadOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default EnhancedSettingsBusinessHours;
